import './App.css';
import Footer from './Components/Footer';
import Home from "./Pages/Home";

function App() {
  return (
    <div className="app-body">
      <Home />
      <Footer/>
    </div>
  );
}

export default App;
